import { render, staticRenderFns } from "./FactMatchResult.vue?vue&type=template&id=9307c4ac&"
import script from "./FactMatchResult.vue?vue&type=script&lang=js&"
export * from "./FactMatchResult.vue?vue&type=script&lang=js&"
import style0 from "./FactMatchResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9307c4ac')) {
      api.createRecord('9307c4ac', component.options)
    } else {
      api.reload('9307c4ac', component.options)
    }
    module.hot.accept("./FactMatchResult.vue?vue&type=template&id=9307c4ac&", function () {
      api.rerender('9307c4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/FactMatchResult.vue"
export default component.exports